import { useState } from "react";
import { services } from "@/mocks/landing";

export default function Services() {
  const [active, setActive] = useState<string>(services[0].id);

  return (
    <section id="services" className="bg-background-50 px-4 md:px-10 py-20 md:py-32">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
        <div>
          <p className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-foreground-600 mb-4">
            <span className="w-6 h-px bg-foreground-400"></span>
            What we clean
          </p>
          <h2 className="font-heading text-4xl md:text-6xl font-medium text-foreground-950 max-w-3xl leading-[1.05]">
            Pick the kind of clean<br />your week actually needs.
          </h2>
        </div>
        <p className="text-foreground-700 text-base max-w-sm leading-relaxed">
          From a quick weekly tidy to a full move-out reset, every visit is delivered by the same vetted, insured cleaners.
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-3 lg:h-[560px]">
        {services.map((s) => {
          const isActive = active === s.id;
          return (
            <button
              key={s.id}
              onMouseEnter={() => setActive(s.id)}
              onFocus={() => setActive(s.id)}
              className={`relative overflow-hidden rounded-2xl transition-all duration-700 ease-out text-left ${
                isActive ? "lg:flex-[3]" : "lg:flex-1"
              } h-72 lg:h-full`}
            >
              <img
                src={s.image}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent"></div>

              <div className="relative h-full flex flex-col justify-between p-6 md:p-8">
                <span
                  className={`w-11 h-11 flex items-center justify-center rounded-full transition-colors ${
                    isActive ? "bg-accent-500 text-background-50" : "bg-background-50/85 text-foreground-900"
                  }`}
                >
                  <i className={`${s.icon} text-xl`}></i>
                </span>

                <div className="space-y-3">
                  <h3 className="font-heading text-background-50 text-2xl md:text-3xl font-medium leading-tight">
                    {s.title}
                  </h3>
                  <p
                    className={`text-background-100/90 text-sm leading-relaxed max-w-xs transition-all duration-500 ${
                      isActive ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2 lg:opacity-0"
                    }`}
                  >
                    {s.blurb}
                  </p>
                  <span
                    className={`inline-flex items-center gap-2 text-background-50 text-sm font-medium transition-opacity ${
                      isActive ? "opacity-100" : "opacity-0"
                    }`}
                  >
                    Explore
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}